/**
 * AI Assistant (owner WP3-AI; BUILD-PLAN M10 and M18, prototype ai.html).
 *
 * One workspace with three tabs, each its own route so links and the back
 * button work:
 * - `/assistant`              Ask Velora: questions over read-only practice
 *                             queries, answered with the query and the rows
 * - `/assistant/scribe`       AI scribe: Notes due, capture, structured
 *                             draft, review and sign, voice perio
 * - `/assistant/automations`  rules, Velora's suggestions, approval queue
 *
 * All AI runs through @velora/ai-gateway on the API (HIPAA local-only mode).
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'assistant',
    title: 'AI Assistant',
    version: '0.1.0',
    owner: 'WP3-AI',
    entitlementKey: 'ai_assistant',
    permissions: [
      'patient.view',
      'notes.view',
      'notes.sign',
      'chart.edit',
      'comms.view',
      'comms.send',
      'settings.manage',
    ],
    routes: [
      {
        id: 'ask',
        path: '/assistant',
        title: 'AI Assistant',
        officeScope: 'location-or-all',
        // Ask Velora answers over patient data (the API requires patient.view).
        permission: 'patient.view',
        readsPhi: true,
      },
      {
        id: 'scribe',
        path: '/assistant/scribe',
        title: 'AI scribe',
        officeScope: 'location-or-all',
        permission: 'notes.view',
        readsPhi: true,
        // Sold in the Marketplace as AI Scribe; Ask Velora stays on the
        // workspace's own key.
        entitlementKey: 'ai_scribe',
      },
      {
        id: 'automations',
        path: '/assistant/automations',
        title: 'Automations',
        officeScope: 'location-or-all',
        permission: 'comms.view',
        readsPhi: true,
      },
    ],
    nav: [
      { label: 'AI Assistant', group: 'analytics', routeId: 'ask', icon: 'sparkles', order: 20 },
    ],
    commands: [
      {
        id: 'assistant.open',
        title: 'Ask Velora',
        keywords: ['ai', 'ask', 'question', 'assistant', 'query'],
        routeId: 'ask',
      },
      {
        id: 'assistant.scribe',
        title: 'Open AI scribe notes due',
        keywords: ['scribe', 'soap', 'dictation', 'sign note', 'notes due', 'voice perio'],
        routeId: 'scribe',
        permission: 'notes.view',
      },
      {
        id: 'assistant.automations',
        title: 'Open automations',
        keywords: ['rules', 'workflow', 'approval', 'trigger'],
        routeId: 'automations',
        permission: 'comms.view',
      },
    ],
    sseEntityKeys: ['scribe_session'],
  }),
  pages: {
    ask: () => import('./pages/AskRoute.js'),
    scribe: () => import('./pages/ScribeRoute.js'),
    automations: () => import('./pages/AutomationsRoute.js'),
  },
});
